import React, {useCallback, useEffect, useMemo, useRef, useState,} from "react";
import {BackIcon} from "../../../../assets/icons/profileIcons";
import {useNavigate, useParams} from "react-router-dom";
import {Button, Col, Dropdown, Input, notification, Row,} from "antd";
import {AnniversaryIcon, CakeIcon, CalendarIcon, CalnedarTickIcon,} from "../../../../assets/icons/sidebarIcons";
import {Controller, useForm} from "react-hook-form";
import {checkEmptySpaces, maxLength, Required,} from "../../../utils/patterns";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import {Form} from "react-bootstrap";
import DemoImage from "../../../../assets/images/d-image.png"
import {AiOutlineExpandAlt, AiOutlineShrink} from "react-icons/ai";
import "./ClientDetails.scss";
import SimpleRichTextEditor from "../../../components/common/rich-text-editor/SimpleRichTextEditor";
import "../../../components/common/rich-text-editor/SimpleRichTextEditor.scss";

import {
  DropDownCheck,
  PenIconSession,
  RoundedCheck,
  SearchIcon,
  SFilterIcon,
} from "../../../../assets/icons/defaultIcons";
import PreviousSession from "./PreviousSession";
import {CoachingClientById, CreateCoachSessions, GetCoachSessions,} from "../../../services/coaching.service";
import {formateDate} from "../../../utils/constant";
import ThemeModals from "../../../components/common/modals/theme-modals/ThemeModals";
import debounce from "lodash.debounce";
import ClientDetailsSkeleton from "../../skeletons/coaching/ClientDetailsSkeleton";
import NoRecord from "../../../components/dashboard/no-record/NoRecord";
import EditCoachNote from "./EditCoachNote";
import EditActionItems from "./EditActionItems";
import EditSessionNote from "./EditSessionNote";
import {LuPlus} from "react-icons/lu";
import {UserAuthService} from "../../../services/user-auth-api.service";

import EditAnniversary from "./EditAnniversary";
import EditClientWins from "./EditClientWins";

const ClientDetails = () => {
  let { id } = useParams();
  let navigate = useNavigate();
  const seesionRef = useRef("");
  const [sessionEdit, setSessionEdit] = useState(null);
  const [filterSelected, setSelectedFilter] = useState("All");
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingSession, setIsLoadingSession] = useState(true);
  const [isReadMore, setIsReadMore] = useState(false);
  const [loader , setLoader] = useState(false)
  const [clientSession, setClientSession] = useState([]);
  const [clientData, setClientData] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [alertModalIsOpen, setAlertModalIsOpen] = useState(false);
  const [renderContent, setRenderContent] = useState(false);
  const [editCoachNote, setEditCoachNote] = useState(false);
  const [editActionItems, setEditActionItems] = useState(false);
  const [editClientWins, setEditClientWins] = useState(false);
  const [editSessionNote, setEditSessionNote] = useState(false);
  const [expand, setExpand] = useState(false);
  const [editSessionContent, setEditSessionContent] = useState(false);
  const [searchVal, setSearchVal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authUser, setAuthUser] = useState('')

  let todayData = new Date();

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  async function GetProfileData() {
    setLoading(true)
    const response = await UserAuthService.getProfileData();
    if (response?.data?.data?.status) {
      setLoading(false)
      setAuthUser(response.data?.data?.data?.user)
      if (!response.data?.data?.data?.user?.isCoach){
        navigate('/')
      }
    }
  }

  useEffect(() => {
    GetProfileData();
  }, []);

  const {
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
    control,
    clearErrors,
    watch,
  } = useForm({
    mode: "onChange",
  });

  const onSubmit = async (data) => {
    setLoader(true)
    let payload = {
      clientId: id,
      sessionNote: data?.session_note, // Now contains HTML content from the rich text editor
    };
    try {
      let res = await CreateCoachSessions(payload);
      if (res?.data?.data?.status) {
        notification.success({
          message: "Success",
          description: res?.data?.data?.message,
          placement: "topRight",
          icon: <RoundedCheck />,
          duration: 2,
        });
        reset();
        setLoader(false)
        HandleSession()
      }
    } catch (error) {
      console.error("Error creating session:", error);
    } finally {
      setLoader(false)
    }
  };

  const HandleSelectFilter = (val) => {
    setSelectedFilter(val);
  };

  const items = [
    {
      key: "1",
      label: (
          <a
              onClick={() => HandleSelectFilter("All")}
              className={"d-flex justify-content-between w-100"}
          >
            All{" "}
            {filterSelected === "All" && (
                <span>
              <DropDownCheck />
            </span>
            )}
          </a>
      ),
    },
    {
      key: "2",
      label: (
          <a
              onClick={() => HandleSelectFilter("Newest")}
              className={"d-flex justify-content-between w-100"}
          >
            Newest{" "}
            {filterSelected === "Newest" && (
                <span>
              <DropDownCheck />
            </span>
            )}
          </a>
      ),
    },
    {
      key: "3",
      label: (
          <a
              onClick={() => HandleSelectFilter("Oldest")}
              className={"d-flex justify-content-between w-100"}
          >
            Oldest{" "}
            {filterSelected === "Oldest" && (
                <span>
              <DropDownCheck />
            </span>
            )}
          </a>
      ),
    },
  ];

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      setSearchVal(event.target.value);
    }
  };

  // useEffect(() => {
  //   if (sessionEdit !== null) {
  //     setValue("session_note", sessionEdit?.sessionNote);
  //     setValue("coach_note", sessionEdit?.coachNote);
  //     setValue("action_items", sessionEdit?.actionItems);
  //     setValue("start_date", sessionEdit?.coachingStart);
  //     setValue("end_date", sessionEdit?.coachingEnd);
  //     setValue("aniversary_date", sessionEdit?.anniversary);
  //   }
  // }, [sessionEdit]);

  const HandleGetClientById = async () => {
    let res = await CoachingClientById(id);
    setClientData(res?.data?.data?.data);
    setIsLoading(false);
  };

  const HandleSession = async (searchTerm) => {
    let orderBy =
        filterSelected == "Newest"
            ? "desc"
            : filterSelected == "Oldest"
            ? "asc"
            : "desc";
    let sessionParams = {
      clientId: id,
      search: searchTerm,
      pagination: false,
      sort: "createdAt",
      order: orderBy,
    };
    let response = await GetCoachSessions(sessionParams);
    setClientSession(response?.data?.data?.data?.sessions);
    setIsLoadingSession(false);
  };

  const debouncedHandleSearch = useMemo(
      () =>
          debounce(async (newSearchTerm) => {
            if (newSearchTerm) {
              HandleSession(newSearchTerm);
            } else {
              HandleSession();
            }
          }, 500),
      []
  );

  const debounceRequest = useCallback(
      (newSearchTerm) => debouncedHandleSearch(newSearchTerm),
      [debouncedHandleSearch]
  );

  useEffect(() => {
    setIsLoading(true);
    setIsLoadingSession(true);
    HandleGetClientById();
  }, [renderContent]);

  useEffect(() => {
    HandleSession();
  }, [filterSelected, renderContent]);

  const HandleBack = () => {
    if (sessionEdit !== null) {
      setAlertModalIsOpen(true);
    } else {
      navigate(-1);
    }
  };

  if (isLoading || isLoadingSession) {
    return <ClientDetailsSkeleton/>;
  }

  return (
      <>
        <div>
          <div className="main_div_client_details">
            <div className="inner_div">
              <div className="header">
              <span onClick={HandleBack}>
                <BackIcon />
              </span>
                <h3 className={'btn-head'}><span>{clientData?.fullName}
                </span>
                  {/*<small> Add Note <span className={'add-btn'} onClick={()=>{navigate(`/coaching/add-note/${id}`)}}><AiOutlinePlus /></span></small> */}
                </h3>
              </div>

              <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
                <Col xs={24} lg={24} xl={expand ? 24: 12} md={expand ? 24 : 12} className={expand ? 'full-width-col' : ''}>
                  <div className={`col_1_div ${expand ? 'expanded-notes' : ''}`}>
                    <div className="inner_div_col_1">
                      <div className="client_info">
                        <div className="inner_client_info">
                          <p>Client Info</p>
                          <span onClick={() => setModalIsOpen(true)}>
                              <PenIconSession />
                          </span>
                        </div>
                        <div className="profile">
                          <div className="img_div">
                            <img src={clientData?.profileImage || DemoImage} />
                          </div>
                          <div>
                            <p>{clientData?.fullName}</p>
                            <p className="para">{clientData?.email}</p>
                          </div>
                        </div>
                        {/*<div className="events_section">*/}
                        {/*  <div className="inner_events">*/}
                        {/*    <CalendarIcon />*/}
                        {/*    <p>Coaching Start</p>*/}
                        {/*  </div>*/}
                        {/*  <p>*/}
                        {/*    {clientData?.lastSession !== null &&*/}
                        {/*    clientData?.lastSession?.coachingStart*/}
                        {/*        ? formateDate(*/}
                        {/*            clientData?.lastSession?.coachingStart*/}
                        {/*        )*/}
                        {/*        : "-"}*/}
                        {/*  </p>*/}
                        {/*</div>*/}
                        {/*<div className="events_section">*/}
                        {/*  <div className="inner_events">*/}
                        {/*    <CalnedarTickIcon />*/}
                        {/*    <p>Coaching End</p>*/}
                        {/*  </div>*/}
                        {/*  <p>*/}
                        {/*    {" "}*/}
                        {/*    {clientData?.lastSession !== null &&*/}
                        {/*    clientData?.lastSession?.coachingEnd*/}
                        {/*        ? formateDate(clientData?.lastSession?.coachingEnd)*/}
                        {/*        : "-"}*/}
                        {/*  </p>*/}
                        {/*</div>*/}
                        {clientData?.dob && (
                          <div className="events_section">
                            <div className="inner_events">
                              <CakeIcon />
                              <p>Birthday</p>
                            </div>
                            <p>{formateDate(clientData.dob)}</p>
                          </div>
                        )}
                        
                        {clientData?.anniversary && (
                          <div className="events_section">
                            <div className="inner_events">
                              <AnniversaryIcon />
                              <p>Anniversary</p>
                            </div>
                            <p>{formateDate(clientData.anniversary)}</p>
                          </div>
                        )}

                        {clientData?.startDate && (
                          <div className="events_section">
                            <div className="inner_events">
                              <CalendarIcon/>
                              <p>Start Date</p>
                            </div>
                            <p>{formateDate(clientData.startDate)}</p>
                          </div>
                        )}

                        {clientData?.endDate && (
                          <div className="events_section">
                            <div className="inner_events">
                              <CalnedarTickIcon />
                              <p>End Date</p>
                            </div>
                            <p>{formateDate(clientData.endDate)}</p>
                          </div>
                        )}
                      </div>
                      {/*<div className="session_main_div">*/}
                      {/*  <h5>Session Note:</h5>*/}
                      {/*  <div className={"dfields"}>*/}
                      {/*    <Controller*/}
                      {/*        name="session_note"*/}
                      {/*        // defaultValue={"Evan"}*/}
                      {/*        control={control}*/}
                      {/*        rules={{*/}
                      {/*          required: Required,*/}
                      {/*          maxLength: maxLength(500),*/}
                      {/*          validate: checkEmptySpaces,*/}
                      {/*        }}*/}
                      {/*        render={({ field: { name, ...field } }) => (*/}
                      {/*            <DescriptionInput*/}
                      {/*                rows={15}*/}
                      {/*                autoSize={{ minRows: 15, maxRows: 16 }}*/}
                      {/*                placeholder={""}*/}
                      {/*                label={""}*/}
                      {/*                type={"text"}*/}
                      {/*                field={field}*/}
                      {/*                errors={errors.session_note}*/}
                      {/*                className={"required"}*/}
                      {/*            />*/}
                      {/*        )}*/}
                      {/*    />*/}
                      {/*  </div>*/}

                      {/*  <div className={"dfields"} style={{ marginTop: 38 }}>*/}
                      {/*    <ThemeButton*/}
                      {/*        text={"Submit"}*/}
                      {/*        className={"btn-light-lg"}*/}
                      {/*        type={"submit"}*/}
                      {/*    />*/}
                      {/*  </div>*/}
                      {/*</div>*/}
                    </div>
                  </div>
                  <div className="col_1_div mt-3">
                    <div className="inner_div_col_1">
                      {/*<div className="form_div">*/}
                      {/*  <h5>Coach Note</h5>*/}
                      {/*  <div className={"dfields"}>*/}
                      {/*    <Controller*/}
                      {/*        name="coach_note"*/}
                      {/*        // defaultValue={"Evan"}*/}
                      {/*        control={control}*/}
                      {/*        rules={{*/}
                      {/*          required: Required,*/}
                      {/*          maxLength: maxLength(500),*/}
                      {/*          validate: checkEmptySpaces,*/}
                      {/*        }}*/}
                      {/*        render={({ field: { name, ...field } }) => (*/}
                      {/*            <DescriptionInput*/}
                      {/*                rows={10}*/}
                      {/*                autoSize={{ minRows: 10, maxRows: 11 }}*/}
                      {/*                placeholder={"Write your coaching notes here..."}*/}
                      {/*                label={""}*/}
                      {/*                type={"text"}*/}
                      {/*                field={field}*/}
                      {/*                errors={errors.coach_note}*/}
                      {/*                className={"required"}*/}
                      {/*            />*/}
                      {/*        )}*/}
                      {/*    />*/}
                      {/*  </div>*/}
                      {/*</div>*/}
                      {/*<div className="form_div">*/}
                      {/*  <h5>Action Items</h5>*/}

                      {/*  <div className={"dfields"}>*/}
                      {/*    <Controller*/}
                      {/*        name="action_items"*/}
                      {/*        // defaultValue={"Evan"}*/}
                      {/*        control={control}*/}
                      {/*        rules={{*/}
                      {/*          required: Required,*/}
                      {/*          maxLength: maxLength(500),*/}
                      {/*          validate: checkEmptySpaces,*/}
                      {/*        }}*/}
                      {/*        render={({ field: { name, ...field } }) => (*/}
                      {/*            <DescriptionInput*/}
                      {/*                rows={10}*/}
                      {/*                autoSize={{ minRows: 10, maxRows: 11 }}*/}
                      {/*                placeholder={"Write a action Description here..."}*/}
                      {/*                label={""}*/}
                      {/*                type={"text"}*/}
                      {/*                field={field}*/}
                      {/*                errors={errors.action_items}*/}
                      {/*                className={"required"}*/}
                      {/*            />*/}
                      {/*        )}*/}
                      {/*    />*/}
                      {/*  </div>*/}
                      {/*</div>*/}

                      <div className="session_main_div">
                        {!expand && (
                          <Form onSubmit={handleSubmit(onSubmit)}>
                            <h5 className={'session-note-heading pt-0'}>Session Note:
                              <span onClick={()=>{setExpand(true)}}><AiOutlineExpandAlt /></span>
                            </h5>
                            <div className="dfields">
                              <Controller
                                  name="session_note"
                                  control={control}
                                  rules={{
                                    required: Required,
                                    maxLength: maxLength(10000),
                                    validate: checkEmptySpaces,
                                  }}
                                  render={({ field }) => (
                                      <SimpleRichTextEditor
                                          value={field.value}
                                          onChange={field.onChange}
                                          placeholder={"Add your session notes here..."}
                                          className="required"
                                          error={errors.session_note}
                                      />
                                  )}
                              />
                            </div>
                            <div className={"dfields"} style={{ marginTop: 38 }}>
                              <ThemeButton
                                  text={"Submit"}
                                  className={"btn-light-lg"}
                                  type={"submit"}
                                  loader={loader}
                              />
                            </div>
                          </Form>
                        )}
                      </div>



                    </div>
                  </div>
                </Col>
                <Col className={expand ? 'd-none' : 'd-block'} xs={24} lg={24} xl={12} md={12}>
                  <div className="col_1_div">
                    <div className="inner_div_col_1">
                      <div className="session_main_div">
                        <h5 className={'session-heading pt-0'}>Coach Note: {clientData?.coachNote ?
                            <span className={'cp'} onClick={() => setEditCoachNote(true)}><PenIconSession /></span>
                            :
                            <span className={'add-btn-text'} onClick={() => setEditCoachNote(true)}><LuPlus /> Add Coach Note</span>}
                        </h5>
                        <div className={'section-para-box'}>
                          <p style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }} className={'section-para'}>
                            {
                              clientData?.coachNote && clientData?.coachNote
                            }
                          </p>
                        </div>

                      </div>
                      <div className="session_main_div">
                        <h5 className={'session-heading'}>Action Items: {clientData?.actionItems ?  <span className={'cp'} onClick={() => setEditActionItems(true)}><PenIconSession /></span> : <span className={'add-btn-text'} onClick={() => setEditActionItems(true)}><LuPlus /> Add Action Items</span>}</h5>
                        <div className={'section-para-box'}>
                          <p style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }} className={'section-para'}>
                            {
                              clientData?.actionItems && clientData?.actionItems
                            }
                          </p>
                        </div>

                      </div>

                      <div className="session_main_div">
                        <h5 className={'session-heading'}>Client Wins {clientData?.clientWins ?
                            <span className={'cp'} onClick={() => setEditClientWins(true)}><PenIconSession /></span>
                            :
                            <span className={'add-btn-text'} onClick={() => setEditClientWins(true)}><LuPlus /> Add Client Wins</span>}
                        </h5>
                        <div className={'section-para-box'}>
                          <p style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }} className={'section-para'}>
                            {
                              clientData?.clientWins && clientData?.clientWins
                            }
                          </p>
                        </div>

                      </div>

                      <div className="previous_session_div">
                        <div className="header">
                          <h5>Previous Session notes</h5>
                          <div>
                            <Dropdown
                                menu={{ items }}
                                placement="bottomLeft"
                                trigger={"click"}
                            >
                            <span className={"theme-dropdown-1"}>
                              <SFilterIcon />{" "}
                              {filterSelected ? filterSelected : ""}
                            </span>
                            </Dropdown>
                          </div>
                        </div>
                        <div className="search_input">
                          <div className={""}>
                            <Controller
                                name="search"
                                defaultValue={""}
                                control={control}
                                rules={{ maxLength: maxLength(500) }}
                                render={({ field: { name, ...field } }) => (
                                    <div className={"text-field"}>
                                      <Input
                                          {...field}
                                          placeholder={"Search"}
                                          status={errors.search && "error"}
                                          prefix={<SearchIcon />}
                                          type={"text"}
                                          // onChange={(e) => {
                                          //
                                          // }}
                                          onKeyDown={(e) => {
                                            // e.preventDefault();
                                            const value = e.target.value;
                                            field.onChange(value);
                                            debounceRequest(value);
                                            setSearchVal(value);
                                          }}
                                      />
                                    </div>
                                )}
                            />
                          </div>
                        </div>
                        <div className="mt-5 client_session">
                          {clientSession?.length > 0 ? (
                              <>
                                {clientSession &&
                                clientSession?.map((v, i) => {
                                  return (
                                      <PreviousSession
                                          Data={v}
                                          setSessionEdit={setSessionEdit}
                                          sessionEdit={sessionEdit}
                                          open={setEditSessionNote}
                                      />
                                  );
                                })}
                              </>
                          ) : (
                              <NoRecord/>
                          )}
                        </div>
                      </div>

                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
            <ThemeModals
                open={editCoachNote}
                close={setEditCoachNote}
                title={'Coach Note'}
                // className={"forum_modal"}
                content={
                  <EditCoachNote open={editCoachNote} close={setEditCoachNote} clientData={clientData} setClientData={setClientData}/>
                }
            />
          <ThemeModals
              open={editActionItems}
              close={setEditActionItems}
              title={'Action Items'}
              // className={"forum_modal"}
              content={
                <EditActionItems open={editActionItems} close={setEditActionItems} clientData={clientData} setClientData={setClientData}/>
              }
          />
          <ThemeModals
              open={editClientWins}
              close={setEditClientWins}
              title={'Client Wins'}
              // className={"forum_modal"}
              content={
                <EditClientWins open={editClientWins} close={setEditClientWins} clientData={clientData} setClientData={setClientData}/>
              }
          />
          <ThemeModals
              open={editSessionNote}
              close={setEditSessionNote}
              title={'Session Note'}
              // className={"forum_modal"}
              content={
                <EditSessionNote open={editSessionNote} close={setEditSessionNote} sessionData={sessionEdit} handleSession={HandleSession} id={id}/>
              }
               width={620}
          />
          <ThemeModals
              open={modalIsOpen}
              close={setModalIsOpen}
              title={'Edit Anniversary'}
              className={"forum_modal"}
              content={
               <EditAnniversary clientData={clientData} open={modalIsOpen} close={setModalIsOpen} id={id} HandleGetClientById={HandleGetClientById}/>
              }
          />
          <ThemeModals
              open={alertModalIsOpen}
              close={setAlertModalIsOpen}
              title={"Alert"}
              className={"forum_modal"}
              content={
                <div>
                  <p style={{ color: "white", fontSize: "15px" }}>
                    You have not saved you changes, are you sure you want to leave
                    this page.
                  </p>
                  <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "end",
                        gap: "15px",
                      }}
                  >
                    <Button
                        type="text"
                        style={{ color: "white" }}
                        onClick={() => setAlertModalIsOpen(false)}
                    >
                      No
                    </Button>
                    <Button
                        type="text"
                        style={{
                          color: "black",
                          backgroundColor: "#D2A84E",
                          width: "90px",
                        }}
                        onClick={() => {
                          setAlertModalIsOpen(false);
                          setSessionEdit(null);
                          setRenderContent(!renderContent);
                          reset({
                            session_note: "",
                            coach_note: "",
                            action_items: "",
                          });
                        }}
                    >
                      Yes
                    </Button>
                  </div>
                </div>
              }
          />
        </div>

        {/* Fullscreen Session Notes Component */}
        {expand && (
          <div className="fullscreen-mode">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <h5 className={'session-note-heading pt-0'}>Session Note:
                <span onClick={()=>{setExpand(false)}}><AiOutlineShrink/></span>
              </h5>
              <div className="dfields expanded-fields">
                <Controller
                    name="session_note"
                    control={control}
                    rules={{
                      required: Required,
                      maxLength: maxLength(10000),
                      validate: checkEmptySpaces,
                    }}
                    render={({ field }) => (
                        <SimpleRichTextEditor
                            value={field.value}
                            onChange={field.onChange}
                            placeholder={"Add your session notes here..."}
                            className="required fullscreen-editor"
                            error={errors.session_note}
                        />
                    )}
                />
              </div>
              <div className="submit-button-container">
                <ThemeButton
                    text={"Submit"}
                    className={"btn-light-lg"}
                    type={"submit"}
                    loader={loader}
                />
              </div>
            </Form>
          </div>
        )}
      </>
  );
};

export default ClientDetails;
